export default {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  APPROVED: "approved",
};
